import { Logger } from "@/utils/logger";
import * as Sentry from "@sentry/react";
import { AchievementError } from "@/utils/errors";

export type WsAchieveResponse = {
	type: string;
	success: boolean;
	message: string;
	achievement_id: number | null;
	achievement_slug: string | null;
};

export const getPendingAchievementsList = (): (string | number)[] => {
	try {
		const str = decodeURIComponent(localStorage.getItem("pendingAchievements") || "[]");
		return JSON.parse(str);
	} catch (e) {
		return [];
	}
};


export const handleWsAchieveResponse = (
	response: WsAchieveResponse,
	achieveCb: (id: number | string) => void,
) => {
	try {
		const achievement_id: string | number | null = response.achievement_id || response.achievement_slug;
		if (achievement_id === null || achievement_id === undefined) {
			throw new AchievementError("Achievement ID is null");
		}
		const success = response.success;

		let pendingAchievementsStr = "[]";
		let pendingAchievements: any[] = [];
		try {
			pendingAchievementsStr = decodeURIComponent(
				localStorage.getItem("pendingAchievements") || "[]",
			);
			pendingAchievements = JSON.parse(pendingAchievementsStr);
		} catch (e) {
			pendingAchievements = [];
			pendingAchievementsStr = "[]";
			Sentry.addBreadcrumb({
				category: "achievement",
				message: "Failed to parse pending achievements",
				data: {
					pendingAchievementsStr,
				},
			});
			Sentry.captureException(new AchievementError("Failed to parse pending achievements", e as Error));
		}

		const achievementIndex = pendingAchievements.indexOf(achievement_id);
		if (achievementIndex > -1) {
			pendingAchievements.splice(achievementIndex, 1);
		}

		pendingAchievementsStr = JSON.stringify(pendingAchievements);
		localStorage.setItem(
			"pendingAchievements",
			encodeURIComponent(pendingAchievementsStr),
		);

		if (success) {
			achieveCb(achievement_id);
		}
	} catch (e) {
		Sentry.addBreadcrumb({
			category: "achievement",
			message: "Failed to handle ws achieve response",
			data: {
				response,
			},
		});
		Sentry.captureException(new AchievementError("Failed to handle ws achieve response", e as Error));
		throw e;
	}
};

export const sendPendingAchieves = (ws: WebSocket | null) => {
	try {
		if (!ws) return;

		let pendingAchievementsStr = "[]";
		let pendingAchievements: any[] = [];
		try {
			pendingAchievementsStr = decodeURIComponent(
				localStorage.getItem("pendingAchievements") || "[]",
			);
			pendingAchievements = JSON.parse(pendingAchievementsStr);
		} catch (e) {
			pendingAchievements = [];
			pendingAchievementsStr = "[]";

			Sentry.addBreadcrumb({
				category: "achievement",
				message: "Failed to parse pending achievements",
				data: {
					pendingAchievementsStr,
				},
			});
			Sentry.captureException(new AchievementError("Failed to parse pending achievements", e as Error));
		}

		pendingAchievements.forEach((id) => {
			ws.send(JSON.stringify({
				type: "achieve",
				...(typeof id === "string" ? { achievement_slug: id } : { achievement_id: id }),
			}));
		});

	} catch (e) {
		Sentry.captureException(new AchievementError("Failed to send pending achievements", e as Error));
		throw e;
	}

};